import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from "react-i18next";


const Reasons = () => {

  const { t } = useTranslation();

  const data = [
    {
      title: "reach_a_welth_of_travelers",
      image: "https://images.pexels.com/photos/34328172/pexels-photo-34328172.jpeg",
      caption:"reach_a_welth_of_travelers_caption"
    },
    {
      title: "leverage_tech_built_for_your_business",
      image: "https://images.pexels.com/photos/3182829/pexels-photo-3182829.jpeg",
      caption:"leverage_tech_built_for_your_business_caption"
    },
    {
      title: "stand_out_with_powerful_advertising",
      image: "https://images.pexels.com/photos/244133/pexels-photo-244133.jpeg",
      caption:"stand_out_with_powerful_advertising_caption"
    },
    {
      title: "unlock_sustainable_growth",
      image: "https://images.pexels.com/photos/7971194/pexels-photo-7971194.jpeg",
      caption:"unlock_sustainable_growth_caption"
    }
  ]

  return (
    <section className='py-5 container-xl'>

      <div className='mt-5'>
        <div
          className='fs-1 text-center'
          dangerouslySetInnerHTML={{ __html: t('success_title') }}
        ></div>

        <p className='text-center'>{t('success_caption')}</p>

        <div className='mt-5'>
          <Row className='justify-content-center row-gap-4'>
            {data.map((item, index) => (
              <Col sm="12" md="12" lg="6" xl="3" key={index}>

                <div className='reason-card'>

                  <img
                    src={item.image}
                    alt={item.title}
                    className='reason-image'
                  />

                 <div className='reason-overlay'>

  <div className='reason-content'>

    {/* title visible par défaut */}
    <div className='reason-title p-4 fs-5 text-white'>
      {t(item.title)}
    </div>

    {/* caption qui monte au hover */}
    <div className='reason-caption px-4 pb-4 pt-2 text-white'>
      {t(item.caption)}
    </div>

  </div>

</div>

                </div>

              </Col>
            ))}
          </Row>
        </div>
      </div>

    </section>
  )
}

export default Reasons